module.exports = __webpack_public_path__ + "static/media/22ESCWA12.af0959a1.jpg";